import React from "react";
import { Button, Tooltip, Typography } from "antd";
import ModalContentHelper from "./ModalContentHelper";

export default function ContentHelper() {
  const [visibleDialog, setVisibleDialog] = React.useState(false);

  return (
    <div>
      <ModalContentHelper
        visible={visibleDialog}
        onClose={() => setVisibleDialog(false)}
      />

      <p>
        You can write variables to auto-populate, such as <Typography.Text code>[job.name]</Typography.Text> will fill in the name of the job.
        <span className="link-primary ml-1" onClick={() => setVisibleDialog(true)}>
          View More!
        </span>
      </p>
    </div>
  );
}